module.exports = {"220106001":"正阳街道","220106003":"春城街道","220106005":"青年街道","220106006":"普阳街道","220106007":"铁西街道","220106010":"林园街道","220106011":"同心街道","220106100":"合心镇","220106101":"西新镇","220106102":"城西镇","220106400":"绿园经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220106.json
// module id = 607
// module chunks = 0